import { AppColors, ShowAnchorsContext } from "Constants";
// import Image1 from "assets/img/home-page-carousel/1.webp";
// import Image2 from "assets/img/home-page-carousel/2.webp";
// import Image3 from "assets/img/home-page-carousel/3.webp";
// import Image1Fallback from "assets/img/home-page-carousel/fallbacks/1.webp";
// import Image2Fallback from "assets/img/home-page-carousel/fallbacks/2.webp";
// import Image3Fallback from "assets/img/home-page-carousel/fallbacks/3.webp";
import { useContext } from "react";
// import { FcNext, FcPrevious } from "react-icons/fc";
import { Img } from "react-image";
// import Slider, { Settings } from "react-slick";
// const Slider = lazy(async () => import("react-slick"));
import AwesomeSlider from "react-awesome-slider";
import withAutoplay from "react-awesome-slider/dist/autoplay";
const Slider = withAutoplay(AwesomeSlider);

const BannersCarousel = () => {
  const showAnchor = useContext(ShowAnchorsContext);

  const bannersList = [
    {
      src: process.env.PUBLIC_URL + "/assets/img/home-page-carousel/1.webp",
      fallback:
        process.env.PUBLIC_URL +
        "/assets/img/home-page-carousel/fallbacks/1.webp",
    },
    {
      src: process.env.PUBLIC_URL + "/assets/img/home-page-carousel/2.webp",
      fallback:
        process.env.PUBLIC_URL +
        "/assets/img/home-page-carousel/fallbacks/2.webp",
    },
    {
      src: process.env.PUBLIC_URL + "/assets/img/home-page-carousel/3.webp",
      fallback:
        process.env.PUBLIC_URL +
        "/assets/img/home-page-carousel/fallbacks/3.webp",
    },
  ];
  // const bannersList = [
  //   { src: Image1, fallback: Image1Fallback },
  //   { src: Image2, fallback: Image2Fallback },
  //   { src: Image3, fallback: Image3Fallback },
  // ];

  return (
    <div
      className="container-fluid p-0 mb-5"
      id={showAnchor ? "banners-slider" : ""}
      // style={{ minHeight: "90vh" }}
    >
      {/* <Suspense
        fallback={
          <Img
            src={bannersList[0].fallback}
            className="img-fluid"
            alt=""
            width="100%"
            style={{ aspectRatio: "2/1" }}
          />
        }
      > */}
      <Slider
        mobileTouch
        animation="scaleOutAnimation"
        bullets={false}
        play={true}
        cancelOnInteraction={false} // should stop playing on user interaction
        interval={6000}
        timerHeight="0"
        className="banner-slider"
      >
        {bannersList.map(({ src: imageUrl, fallback }, idx) => (
          <div className="item" key={idx}>
            <Img
              className="img-fluid"
              src={imageUrl}
              alt=""
              width="100%"
              style={{ aspectRatio: "2/1" }}
              loader={
                <Img
                  className="img-fluid"
                  src={fallback}
                  alt=""
                  width="100%"
                  style={{ aspectRatio: "2/1" }}
                />
              }
            />
          </div>
        ))}
      </Slider>
      {/* </Suspense> */}
    </div>
  );
};

export default BannersCarousel;
